import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Alert,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { commonToast, numberToWords } from "../Utils";
import axios from "../axios";
import urls from "../Utils/urls";
import { toast } from "react-toastify";
import ChequeComponent from "./ChequeComponent";
import { useAbortController } from "../hooks/useAbortController";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { LoadingButton } from "../Utils/CustomComponent";
import { handleTermsPopup } from "../store/reducers/dashboardSlice";
import PopupWrapper from "./PopupWrapper";
import { oracleConfig } from "../Utils/constant";

const ChequeForm = () => {
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const userId = localStorage.getItem("apex_userid");
  const chequeData = useSelector((state) => state.achPayment.sameDayPayment);
  const [chequeNumber, setChequeNumber] = useState(null);
  // const [routingNumber, setRoutingNumber] = useState(null);
  // const [bankAccountNumber, setBankAccountNumber] = useState(null);
  const [validDate, setValidDate] = useState(true);
  const [checkNoPrompt, setcheckNoPrompt] = useState(null);
  const navigate = useNavigate();
  const accountId = useSelector((state) => state.account.lenderId);
  const routingDetails = useSelector(
    (state) => state.achPayment.routingDetails
  );
  const { signal } = useAbortController();
  const location = useLocation();
  const isOneTimeACH = location?.state?.parent === "One Time";

  // const now = moment.tz("America/Los_Angeles");
  // const cutoff = now.clone().hour(15).minute(0).second(0).millisecond(0);

  // let candidate = now.isBefore(cutoff)
  //   ? now.clone()
  //   : now.clone().add(1, "day");

  // // Keep moving forward until it's a business day
  // while (!isWeekdayAndNotHoliday(candidate.toDate())) {
  //   candidate.add(1, "day");
  // }

  // const formattedDate = candidate.format("MM/DD/YYYY");
  // let formattedDate = moment().isBefore(moment().hour(17).minute(0))
  //   ? moment().format("MM/DD/YYYY")
  //   : moment().add(1, "day").format("MM/DD/YYYY");
  const [formChequeData, setFormData] = useState([
    {
      payTo: chequeData.payTo,
      // date: isOneTimeACH ? chequeData.selectedDate : formattedDate,
      amount: isOneTimeACH
        ? `${Number(chequeData.amount)}`
        : `${Number(chequeData.amount) + 30}`,
      amountInWords: isOneTimeACH
        ? numberToWords(Number(chequeData.amount))
        : numberToWords(Number(chequeData.amount) + 30),
      // chequeNo: chequeNumber,
      memo: chequeData.memo,
      signature: "",
    },
  ]);
  const [sign, setSign] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const isDisabled = sign === null;

  useEffect(() => {
    async function getCurrentDateNTime() {
      try {
        if (isOneTimeACH) {
          setFormData([
            {
              payTo: chequeData.payTo,
              date: chequeData.selectedDate,
              amount: isOneTimeACH
                ? `${Number(chequeData.amount)}`
                : `${Number(chequeData.amount) + 30}`,
              amountInWords: isOneTimeACH
                ? numberToWords(Number(chequeData.amount))
                : numberToWords(Number(chequeData.amount) + 30),
              // chequeNo: chequeNumber,
              memo: chequeData.memo,
              signature: "",
            },
          ]);
        } else {
          const res = await axios.get(urls.borrower.currentDateNTime);

          const now = moment.tz(res?.data?.datetime, "America/Los_Angeles");
          const cutoff = now
            .clone()
            .hour(15)
            .minute(0)
            .second(0)
            .millisecond(0);

          let candidate = now.isBefore(cutoff)
            ? now.clone()
            : now.clone().add(1, "day");

          // Keep moving forward until it's a business day
          while (!isWeekdayAndNotHoliday(candidate)) {
            candidate.add(1, "day");
          }

          const formattedDate = candidate.format("MM/DD/YYYY");
          setValidDate(true);

          setFormData([
            {
              payTo: chequeData.payTo,
              date: isOneTimeACH ? chequeData.selectedDate : formattedDate,
              amount: isOneTimeACH
                ? `${Number(chequeData.amount)}`
                : `${Number(chequeData.amount) + 30}`,
              amountInWords: isOneTimeACH
                ? numberToWords(Number(chequeData.amount))
                : numberToWords(Number(chequeData.amount) + 30),
              // chequeNo: chequeNumber,
              memo: chequeData.memo,
              signature: "",
            },
          ]);
        }
      } catch (error) {
        console.error(error);
        setValidDate(false);
      }
    }
    getCurrentDateNTime();
  }, [chequeData, isOneTimeACH]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFormData = [...formChequeData];
    updatedFormData[index] = {
      ...updatedFormData[index],
      [name]: value,
    };
    setFormData(updatedFormData);
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(urls.borrower.getChequeData3, oracleConfig, {
          signal,
        });
        if (res?.data) {
          setChequeNumber(res.data.items[0].get_ach_seq);
          setcheckNoPrompt(null);
        }
      } catch (error) {
        if (error.name === "CanceledError") {
          console.error("Fetch request canceled", error.message);
        } else {
          // console.error(error);
          console.error("Error fetching cheque number:", error);
          setcheckNoPrompt(
            "The check number could not be loaded. Please refresh the page and try again."
          );
        }
      }
    };
    fetchData();
  }, []);
  // useEffect(() => {
  //   const fetchData2 = async () => {
  //     try {
  //       const res = await axios.get(
  //         urls.borrower.getPaymentsLoanAchSameDayInfo(accountId),
  //         { signal }
  //       );
  //       // Assuming res.data is an array of objects, adjust accordingly
  //       if (res.data && res.data.length > 0) {
  //         let data = res.data[0][0];
  //         setBankAccountNumber(data.ACH_AccountNumber);
  //         setRoutingNumber(data.ACH_RoutingNumber);
  //       } else {
  //         console.error("No data found in the response");
  //       }
  //     } catch (error) {
  //       if (error.name === "CanceledError") {
  //         console.error("Fetch request canceled", error.message);
  //       } else {
  //         console.error("Error fetching loan ACH information:", error);
  //       }
  //     }
  //   };
  //   fetchData2();
  // }, []);

  const UploadAllChequesPDF = async () => {
    if (!chequeNumber) {
      setcheckNoPrompt(
        "The check number could not be loaded. Please refresh the page and try again."
      );
      return;
    }
    setcheckNoPrompt(null);
    setDisableBtn(true);
    const id = toast.loading("Upload Cheque Pending");

    // Convert Base64 image to a Blob
    const response = await fetch(formChequeData?.[0].signature);
    const blob = await response.blob();

    // Convert Blob to Base64
    const convertBlobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
      });
    };

    try {
      const base64Signature = await convertBlobToBase64(blob);
      const { date, amount, amountInWords } = formChequeData?.[0];
      const {
        bankAccountName,
        address,
        cityStateZip,
        payTo,
        memo,
        accountNumber,
        routingNumber,
        isRoutingNumberVerified,
      } = chequeData;

      const res2 = await axios.post(
        urls.borrower.postChequeData3(isOneTimeACH),
        {
          user_id: userId,
          bankAccountName: bankAccountName,
          address: address,
          cityStateZip: cityStateZip,
          date: date,
          chequeNumber: chequeNumber,
          payTo: payTo,
          amount: `${amount}`,
          amountInWords: amountInWords,
          memo: memo,
          bankAccountNumber: accountNumber,
          routingNumber: routingNumber,
          signature: base64Signature,
          loanAccountNumber: chequeData.loan_account_number,
          isRoutingNumberVerified: isRoutingNumberVerified,
          bankDetailsByRN: isRoutingNumberVerified
            ? JSON.stringify(routingDetails)
            : false,
          loanrecid: accountId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        }
      );
      if (res2 && res2?.status === 200) {
        if (res2.data && res2.data.includes("Unexpected error")) {
          return toast.update(id, {
            render: `Upload Failed - Unexpected error in procedure: ORA-06502: PL/SQL: numeric or value error`,
            type: "error",
            isLoading: false,
            ...commonToast,
          });
        }
        dispatch(handleTermsPopup(false));

        setShowSuccessPopup(true);

        toast.update(id, {
          render: "Cheque Uploaded Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });

        // Clear previous timeout (if any)
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
          setShowSuccessPopup(false);
          navigate("/borrower-dashboard-two");
        }, 20000);
      }
    } catch (error) {
      dispatch(handleTermsPopup(false));
      console.error("Error uploading the cheque", error);
      toast.update(id, {
        render: "Upload Failed",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
      // navigate("/loan-details-borrower");
    } finally {
      setDisableBtn(false);
    }
  };

  return (
    <Container>
      {!validDate && (
        <Alert
          key={"info"}
          variant={"error"}
          className="mt-5 fw-bold text-center"
        >
          Server could not fetch current date and time! Please try again.
        </Alert>
      )}
      {checkNoPrompt && (
        <Alert
          key={"checkNo"}
          variant={"error"}
          className="mt-5 fw-bold text-center"
        >
          {checkNoPrompt}
        </Alert>
      )}
      {/* <Row>
        <Col>
          {!isOneTimeACH ? (
            <div className="mb-3">
              {" "}
              There is a charge of $30 for this service. If you don't need a
              same day payment, you can choose a next day ACH payment instead.
              “Same Day Payments” must be received by 3PM (PT) on each business
              day (excludes holidays).​ Please review your submission. Your
              submission is not complete until you press the "Submit" button!
            </div>
          ) : (
            <div>
              Please review your submission. Your submission is not complete
              until you press the "Submit" button!
            </div>
          )}
        </Col>
      </Row> */}
      <div
        id={`chequeComponent`}
        style={!isLargeDevice ? { fontSize: "small" } : null}
      >
        {formChequeData?.map((data, index) => (
          <ChequeComponent
            key={index}
            formData={data}
            handleChange={(e) => handleChange(index, e)}
            chequeNumber={chequeNumber}
            setFormData={setFormData}
            setSign={setSign}
            readOnly={true}
          />
        ))}
      </div>
      <Row>
        <Col>
          <OverlayTrigger
            key={"cheque"}
            trigger={"hover"}
            placement={"right"}
            overlay={
              isDisabled ? (
                <Tooltip id={`tooltip-${"cheque"}`}>
                  Your signature is required!
                </Tooltip>
              ) : (
                <span></span> // Empty element when the button is not disabled
              )
            }
          >
            <div
              style={{
                display: "inline-block",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
            >
              {/* <button
                className="btn btn-primary mt-3"
                onClick={UploadAllChequesPDF}
                disabled={isDisabled}
              >
                Submit
              </button> */}
              <LoadingButton
                type="button"
                className="btn btn-primary mt-3 text-white"
                onClick={UploadAllChequesPDF}
                title={"Submit"}
                disabled={disableBtn || isDisabled || !validDate}
                loading={disableBtn}
              />
            </div>
          </OverlayTrigger>
        </Col>
      </Row>

      <Row>
        <Col>
          {!isOneTimeACH ? (
            <Alert key={"info"} variant={"info"} className="mt-5 fw-bold">
              <div>
                There is a charge of $30 for this service. If you don't need a
                same day payment, you can choose a next day One Time Payment
                instead. “Same Day Payments” must be received by 3PM (PT) on
                each business day (excludes holidays).
              </div>
              <div>
                Please review your submission carefully, especially the routing
                and account numbers on the check image.
              </div>
              <div>
                Click the signature line to sign. Submission isn’t complete
                until you press "Submit." Watch for a confirmation email.
              </div>
              <div>
                If the scheduled date falls on a weekend or public holiday, the
                debit will occur on the next business day. Please allow 1–2
                business days for the payment to be posted to your account.
              </div>
            </Alert>
          ) : (
            <Alert key={"info"} variant={"info"} className="mt-5 fw-bold">
              <div>
                Check Requests Cut Off Time: 11:59 PM Pacific Time (Any requests
                received after 11:59 PM will be processed the next business
                day.)
              </div>
              <div>
                Please review your submission carefully, especially the routing
                and account numbers on the check image.
              </div>
              <div>
                Click the signature line to sign. Submission isn’t complete
                until you press "Submit." Watch for a confirmation email.
              </div>
              <div>
                If the scheduled date falls on a weekend or public holiday, the
                debit will occur on the next business day. Please allow 1–2
                business days for the payment to be posted to your account.
              </div>
            </Alert>
          )}
        </Col>
      </Row>

      <SuccessPopup
        show={showSuccessPopup}
        setShow={setShowSuccessPopup}
        navigate={navigate}
      />
    </Container>
  );
};

export default ChequeForm;

const SuccessPopup = ({ show, setShow, navigate }) => {
  return (
    <PopupWrapper
      title="Payment Successful!"
      extraClass="width-800"
      Component={
        <div>
          <p className="fw-bold text-primary">
            Thank you for your payment. Your payment has been successfully
            Submitted!.
          </p>
        </div>
      }
      toShow={show}
      closeEventHandler={() => {
        setShow(false);
        navigate("/borrower-dashboard-two");
      }}
      titleClassName="text-success"
    />
  );
};

const US_Holidays = [
  "01/01/2026",
  "01/19/2026",
  "02/16/2026",
  "05/23/2026",
  "06/19/2026",
  "07/04/2026",
  "09/07/2026",
  "10/12/2026",
  "11/11/2026",
  "11/26/2026",
  "12/25/2026",
].map((date) => new Date(date).toDateString());

const isWeekdayAndNotHoliday = (date) => {
  const day = date.day();
  return day !== 0 && day !== 6 && !US_Holidays.includes(date.format("MM/DD/YYYY"));
};
